var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-title-bar',{attrs:{"titleArray":_vm.titleArray}})
}
var staticRenderFns = []

export { render, staticRenderFns }